import React, { forwardRef, useEffect, useState } from 'react';
import './Loading.css';

export type ILoadingProps = React.HTMLAttributes<HTMLDivElement>;

const Loading = forwardRef<HTMLDivElement, ILoadingProps>(({ className, ...rest }, ref) => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    // Start fade-in animation after component mounts
    const timer = setTimeout(() => {
      setFadeIn(true);
    }, 50); // Small delay to ensure animation triggers properly

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      ref={ref}
      className={['loading-container', fadeIn && 'fade-in', className].filter(Boolean).join(' ')}
      {...rest}
    >
      <div className="loading-text">Loading...</div>
    </div>
  );
});

Loading.displayName = 'Loading';

export default Loading;
